// extracted by mini-css-extract-plugin
export default {"editButton":"advanceSalaryInstallment_editButton__EICpl","TableBody":"advanceSalaryInstallment_TableBody__RA--J"};